import React from "react";
import style from "./UserActivity.module.css";

import CurrentStreakCard from "../currentStreakCard/CurrentStreakCard";
import ActivityGrid from "../activityGrid/ActivityGrid";
import LongestStreak from "../longestStreak/LongestStreak";

import { useGetUserDailyActivity } from "../../hooks/useGetUserDailyActivity";

function UserActivity({ username }) {
	const { activity, isPending } = useGetUserDailyActivity(username);

	if (isPending) return <></>;

	return (
		<div className={style.streakHolder}>
			<div className={style.main}>
				<CurrentStreakCard activity={activity} />
				<ActivityGrid activity={activity} />
			</div>
			<LongestStreak activity={activity} />
		</div>
	);
}

export default UserActivity;
